var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6272 3.22125C14.261 2.92625 13.7388 2.92625 13.3726 3.22125L7.37256 8.05458C6.94247 8.40104 6.87467 9.03057 7.22114 9.46066C7.5676 9.89076 8.19713 9.95855 8.62722 9.61209L12.9999 6.08966V18C12.9999 18.5523 13.4476 19 13.9999 19C14.5522 19 14.9999 18.5523 14.9999 18V6.08966L19.3726 9.61209C19.8027 9.95855 20.4322 9.89076 20.7786 9.46066C21.1251 9.03057 21.0573 8.40104 20.6272 8.05458L14.6272 3.22125ZM5.99989 18C5.99989 17.4477 5.55218 17 4.99989 17C4.44761 17 3.99989 17.4477 3.99989 18V21C3.99989 23.2091 5.79076 25 7.99989 25H19.9999C22.209 25 23.9999 23.2091 23.9999 21V18C23.9999 17.4477 23.5522 17 22.9999 17C22.4476 17 21.9999 17.4477 21.9999 18V21C21.9999 22.1046 21.1045 23 19.9999 23H7.99989C6.89532 23 5.99989 22.1046 5.99989 21V18Z",
    fill: "#151C22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2abd966d.svg";
export { ForwardRef as ReactComponent };